export interface AssignmentHostSource {
  kind?: string | null;
  startedAt?: string | null;
  executorName?: string | null;
  executorKeyId?: string | null;
}

export interface AssignmentWorkerSource {
  workerId: string | null;
  workerServiceName: string | null;
  workerHostName: string | null;
  workerVersion: string | null;
}

export function readAssignmentHost(item: object): Pick<AssignmentHostSource, 'executorName' | 'executorKeyId'> {
  const record = item as AssignmentHostSource;
  const executorName = record.executorName?.trim() || null;
  const executorKeyId = record.executorKeyId?.trim() || null;
  return { executorName, executorKeyId };
}

/** Worker stamped at claim. Empty strings become null. Воркер, записанный при claim. Пустые строки становятся null. */
export function readAssignmentWorker(item: object): AssignmentWorkerSource {
  const record = item as AssignmentWorkerSource;
  return {
    workerId: record.workerId?.trim() || null,
    workerServiceName: record.workerServiceName?.trim() || null,
    workerHostName: record.workerHostName?.trim() || null,
    workerVersion: record.workerVersion?.trim() || null,
  };
}

/** Display label for who ran an assignment. `Monolith` is an i18n key. */
export function assignmentHostLabel(source: AssignmentHostSource): string {
  const name = source.executorName?.trim();
  if (name) {
    return name;
  }
  const keyId = source.executorKeyId?.trim();
  if (keyId) {
    return keyId;
  }
  if (source.kind === 'JobExecution') {
    return '—';
  }
  if (source.startedAt) {
    return 'Monolith';
  }
  return '—';
}
